export default __webpack_public_path__ + "static/media/IMG_2757cropped.6a1090f0.jpeg";